module.exports = __webpack_public_path__ + "static/img/exposure-mobile-3.fc5323c7.png";